import { useState, useEffect } from 'react';
import useApiCaller from 'hooks/apiCaller';

const useCorrectiveBranches = () => {
  const [branches, setBranches] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiCaller = useApiCaller();

  useEffect(() => {
    const fetchCorrectiveBranches = async () => {
      try {
        const response = await apiCaller.post('/user/corrective-branches');
        setBranches(response?.data?.data || []);
      } catch (err) {
        console.error('Error fetching corrective branches:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCorrectiveBranches();
  }, []);

  return { branches, isLoading, error };
};

export default useCorrectiveBranches;
